import { useLocation, useOutletContext } from 'react-router-dom'

import { TrainingMembershipsDataTableQuery } from 'generated/resources/datatable.graphql'
import compact from 'lodash/compact'

import { useDataTable } from 'modules/core/components/DataTable'

import { AddToClassModal } from 'modules/trainings/components/Revamp/TrainingsDetail/TrainingEmployeesDataTable/AddToClassModal'
import { BulkSelection } from 'modules/trainings/components/Revamp/TrainingsDetail/ParticipantsOneDataTable/hooks/useBulkActionsConfig'
import { DetailOutletContext } from 'modules/trainings/pages/Trainings/Revamp/TrainingDetail/Detail/types'

interface LocationState {
  selection?: BulkSelection
  // TODO: Remove this once DataTable is removed
  selectedAccessIds?: number[]
}

const isLocationState = (state: unknown): state is LocationState => {
  return (
    typeof state === 'object' &&
    state !== null &&
    ('selection' in state || 'selectedAccessIds' in state || Object.keys(state).length === 0)
  )
}

const toBackendSelection = (selection: BulkSelection) => {
  if (selection.type === 'all') {
    return {
      type: 'all' as const,
      excludedIds: selection.excludedIds,
    }
  }
  return undefined
}

const AssignParticipantsWithOneCollection = () => {
  const location = useLocation()

  if (!isLocationState(location.state) || !location.state.selection) {
    return <AddToClassModal accessIds={[]} />
  }

  const { selection } = location.state

  if (selection.type === 'all') {
    return <AddToClassModal selection={toBackendSelection(selection)} filters={selection.filters} />
  }

  return <AddToClassModal accessIds={selection.ids} />
}

const AssignParticipantsWithDataTable = () => {
  const data = useDataTable<TrainingMembershipsDataTableQuery>()
  const selectedAccessIds = compact(
    data.queryResult.data?.trainings.trainingMembershipsConnection.edges.map((membership) => {
      if (data.selectedRows.has(String(membership.node?.id))) {
        return membership.node?.accessId
      }
    })
  )

  return <AddToClassModal accessIds={selectedAccessIds} />
}

const AssignParticipants = () => {
  const context = useOutletContext<DetailOutletContext>()

  if (!context) {
    return null
  }

  const { hasParticipantOneDataCollection } = context

  return hasParticipantOneDataCollection ? (
    <AssignParticipantsWithOneCollection />
  ) : (
    <AssignParticipantsWithDataTable />
  )
}

export default AssignParticipants
